import React from 'react';
import ReactDOM from 'react-dom';
import Global from './shared/layout/Global';

ReactDOM.render(
  <React.StrictMode>
    <Global />
  </React.StrictMode>,
  document.getElementById('root')
);
